import React, { useContext, useState } from "react";
import PsContext from "../../context";
import Header from "../header";
import LibrarySearch from "./libraryList";
import LibraryCatalogue from "./libraryCatalogue";

const LeaveList = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);

  return (
    <>
      <Header backAction={true} title="Library" />
      <div className="page-content-wrapper">
        <div className=" py-3">
          <section className="top-space pt-0 pb-0">
            {context.allowedAccess(
              "mob_allow_library_catelogue",
              "action_list"
            ) ? (
              <LibraryCatalogue titleText={"Library"} />
            ) : (
              <LibrarySearch titleText={"Library"} />
            )}
          </section>
          <section className="top-space "></section>
        </div>
      </div>
    </>
  );
};
export default LeaveList;
